import React from 'react';
import { Link } from 'react-router-dom';
import SEO, { softwareAppSchema } from '../../Components/SEO';
import SEOPageLayout from '../../Components/SEOPageLayout';

export default function Download() {
  const downloadSchema = {
    ...softwareAppSchema(),
    "downloadUrl": "https://checkscript.online/download/checkscript-installer.exe"
  };

  return (
    <SEOPageLayout>
      <SEO
        title="Download CheckScript AI v19.0.0 — Free AI Assessment Assistant"
        description="Download CheckScript AI for Windows. Get the ultimate AI assessment assistant, Neural Driver, and remote desktop in one lightweight application."
        keywords="download CheckScript, AI assessment tool download, free AI study tool, CheckScript download Windows"
        path="/download"
        structuredData={downloadSchema}
      />

      <section className="seo-hero seo-animate">
        <div className="seo-mesh-bg"></div>
        <div className="seo-container seo-container--sm">
          <div className="seo-hero-badge">⬇️ Latest Version: v19.0.0</div>
          <h1 className="seo-h1">
            Download <span className="seo-gradient-text">CheckScript</span>
          </h1>
          <p className="seo-lead">
            Get the most powerful AI study assistant and local inference engine available. Free to download for Windows 10 and 11.
          </p>
          <div className="seo-hero-actions">
            <button className="seo-btn seo-btn--primary seo-btn--lg" style={{ minWidth: '250px' }}>
              Download for Windows (64-bit)
            </button>
          </div>
          <p className="seo-text-muted seo-mt-32" style={{ fontSize: '0.9rem' }}>Version 19.0.0 • 45 MB • Requires Windows 10/11</p>
        </div>
      </section>

      <section className="seo-section seo-section--alt seo-animate">
        <div className="seo-container">
          <div className="seo-bento-grid">
            <div className="seo-bento-box seo-bento-square seo-text-center">
              <div className="seo-card-icon seo-card-icon--cyan seo-mx-auto">1</div>
              <h3 className="seo-h3">Download</h3>
              <p className="seo-text-secondary">Get the lightweight installer. It takes seconds to download on standard connections.</p>
            </div>
            <div className="seo-bento-box seo-bento-square seo-text-center">
              <div className="seo-card-icon seo-card-icon--emerald seo-mx-auto">2</div>
              <h3 className="seo-h3">Install</h3>
              <p className="seo-text-secondary">Run the installer. CheckScript will configure itself and minimize to your system tray.</p>
            </div>
            <div className="seo-bento-box seo-bento-square seo-text-center">
              <div className="seo-card-icon seo-card-icon--amber seo-mx-auto">3</div>
              <h3 className="seo-h3">Activate</h3>
              <p className="seo-text-secondary">Press Alt+O anytime to activate the AI. Purchase credits directly in the app to get started.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="seo-section seo-animate">
        <div className="seo-container seo-container--sm">
          <div className="seo-bento-grid" style={{ gap: '48px' }}>
            <div>
              <h2 className="seo-h2 seo-mb-24">System Requirements</h2>
              <ul className="seo-feature-list">
                <li><strong>OS:</strong> Windows 10 or 11 (64-bit required)</li>
                <li><strong>Processor:</strong> Intel Core i3 / AMD Ryzen 3 or better</li>
                <li><strong>Memory:</strong> 4GB RAM minimum (16GB recommended)</li>
                <li><strong>Storage:</strong> 200MB available space</li>
                <li><strong>GPU (Optional):</strong> NVIDIA GPU with 6GB+ VRAM required ONLY if you intend to use the local Neural Driver AI feature. Cloud AI works on any hardware.</li>
              </ul>
            </div>
            <div className="seo-glass-card">
              <h3 className="seo-h3 seo-mb-24">What's New in v19.0.0</h3>
              <ul className="seo-feature-list" style={{ '--seo-emerald': 'var(--seo-cyan)' }}>
                <li>Advanced stealth capture system Advanced stealth capture system capture</li>
                <li>Integrated Neural Driver (Qwen2-VL support)</li>
                <li>Sub-100ms Ultra-low latency streaming protocol Remote Desktop</li>
                <li>Premium Auto-Typing code generator</li>
                <li>Performance optimizations for low-end CPUs</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="seo-cta seo-animate">
        <div className="seo-container">
          <div className="seo-cta-box" style={{ background: 'var(--seo-surface)' }}>
            <h2 className="seo-h2">Security & Privacy</h2>
            <p className="seo-text-secondary seo-mb-32">
              CheckScript is cryptographically signed to ensure integrity. Some antivirus software may flag our advanced capture engines as a false positive. We recommend adding CheckScript to your antivirus exclusions for optimal performance.
            </p>
            <Link to="/faq" className="seo-btn seo-btn--ghost">Read Security FAQ</Link>
          </div>
        </div>
      </section>
    </SEOPageLayout>
  );
}
